const request = config => {
  config.headers['X-Client-Version'] = `${VERSION}-${process.env.NODE_ENV}`; // eslint-disable-line no-undef
  return config;
}

export default (instance) => {
  instance.interceptors.request.use(request);
}
